import apiClient from '@/utils/apiClient';
import { RawTicket, TicketStatus } from '@/pages/ReceptionistDashboard/FormResponses/types';

const agentPrefix = '/agent/:agentId';
const TICKETS_API_PATH = `/api/v2/receptionist-dashboard${agentPrefix}/tickets`;

export const getTickets = async (
	agentId: string,
	params?: { startDate?: number | null; endDate?: number | null },
): Promise<{ tickets: RawTicket[]; workflowTitleMap: { [key: string]: string } }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: TICKETS_API_PATH.replace(':agentId', agentId),
		params,
	});
	return response;
};

export const updateTicket = async (params: {
	agentId: string;
	callSid: string;
	ticketId: string;
	status?: TicketStatus;
	note?: string;
}): Promise<RawTicket> => {
	const { agentId, callSid, ticketId, ...data } = params;
	const response = await apiClient.request({
		method: 'PATCH',
		endPoint: `${TICKETS_API_PATH.replace(':agentId', agentId)}/${callSid}/${ticketId}`,
		body: data,
	});
	return response.data;
};

export const getTicketsForCall = async (
	agentId: string,
	callSid: string,
): Promise<{ tickets: RawTicket[]; workflowTitleMap: { [key: string]: string } }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `/api/v2/receptionist-dashboard/agent/${agentId}/tickets/${callSid}`,
	});
	return response;
};
